module.exports = __webpack_public_path__ + "static/t_323_718-15578d990b969fde178e024bcdace8b1.png";